import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// Attendance consolidated into the shared /attendance workspace (routes/index.tsx);
// legacy path redirects to its team tab.
const redirectTo = (to: string) => () => React.createElement(Navigate, { to, replace: true });

const SalaryRevisionList = lazy(() => import('../../pages/SalaryRevision/SalaryRevisionList'));
const SalaryRevisionDetail = lazy(() => import('../../pages/SalaryRevision/SalaryRevisionDetail'));
const PendingApprovals = lazy(() => import('../../pages/Approvals/PendingApprovals'));

const AccountantDashboard = lazy(() => import('../../pages/Dashboard/Accountant')); // Add this
const NotFound = lazy(() => import('../../NotFound'));
const Payroll = lazy(() => import('../../pages/HrPayroll/Payroll'));
const Bonuses = lazy(() => import('../../pages/HrPayroll/Bonuses'));
const Deductions = lazy(() => import('../../pages/HrPayroll/Deductions'));
const TaxRules = lazy(() => import('../../pages/HrPayroll/TaxRules'));
const IncomeTaxConfiguration = lazy(() => import('../../pages/HrPayroll/IncomeTaxConfiguration'));
const SalaryStructure = lazy(() => import('../../pages/HrPayroll/SalaryStruture'));
const TaxDocuments = lazy(() => import('../../pages/HrPayroll/TaxDocuments'));
const Payslips = lazy(() => import('../../pages/HrPayroll/Payslips'));
const PayslipTemplates = lazy(() => import('../../pages/HrPayroll/PayslipTemplates'));
const EmployeeAllowances = lazy(() => import('../../pages/HrPayroll/EmployeeAllowances'));
const PayrollsDeduction = lazy(() => import('../../pages/HrPayroll/PayrollDeduction'));
const PayrollBonus = lazy(() => import('../../pages/HrPayroll/PayrollBonus'));
const PayrollTax = lazy(() => import('../../pages/HrPayroll/PayrollTax'));
const GeneratedPayroll = lazy(() => import('../../pages/HrPayroll/GeneratePayroll'));
const PayrollRuns = lazy(() => import('../../pages/HrPayroll/PayrollRuns'));
const PayrollRunDetail = lazy(() => import('../../pages/HrPayroll/PayrollRunDetail'));
const AllEmployeesDetail = lazy(() => import('../../pages/Employees/AllEmployeesDetail'));
const AttendanceSheet = lazy(() => import('../../pages/Employees/AttendanceSheet'));
const FinalSettlementEvaluations = lazy(() => import('../../pages/FinalSettlementRules/SettlementDashboard'));
const ApprovedResignations = lazy(() => import('../../pages/FinalSettlementRules/SettlementQueue'));
const SettlementWorkspace = lazy(() => import('../../pages/FinalSettlementRules/SettlementWorkspace'));
const ReimbursementManagement = lazy(() => import('../../pages/Reibursements/ReimbursementManagement'));
const AttendanceReport = lazy(() => import('../../pages/Employees/AttendanceReport'));

// Provident Fund
const ProvidentFundDashboard = lazy(() => import('../../pages/ProvidentFund/ProvidentFundDashboard'));
const EmployeePFView = lazy(() => import('../../pages/ProvidentFund/EmployeePFView'));
const HrLoansPage = lazy(() => import('../../pages/Loans/HrLoansPage'));

const accountantRoutesConfig = [
  { path: '/v1/accountant/dashboard', component: AccountantDashboard },
  { path: '/v1/tax-management', component: TaxDocuments },
  { path: '/v1/payslips-management', component: Payslips },
  { path: '/v1/payslip-templates', component: PayslipTemplates },
  { path: '/v1/payroll-management', component: Payroll },
  { path: '/v1/bonus-types', component: Bonuses },
  { path: '/v1/deduction-management', component: Deductions },
  { path: '/v1/income-tax-configuration', component: IncomeTaxConfiguration },
  { path: '/v1/tax-rules', component: IncomeTaxConfiguration }, // redirect legacy route
  { path: '/v1/salary-structure', component: SalaryStructure },
  { path: '/v1/accountant/*', component: NotFound },
  { path: '/v1/employee-allowances-management', component: EmployeeAllowances },
  { path: '/v1/payroll-deductions-management', component: PayrollsDeduction },
  { path: '/v1/payroll-bonus-management', component: PayrollBonus },
  { path: '/v1/payroll-tax-management', component: PayrollTax },
  { path: '/v1/generated-payroll', component: GeneratedPayroll },
  { path: '/v1/payroll-runs', component: PayrollRuns },
  { path: '/v1/payroll-runs/:runId', component: PayrollRunDetail },
  { path: '/v1/employees-management', component: AllEmployeesDetail },
  // Legacy attendance path → shared /attendance workspace (defined in routes/index.tsx)
  { path: '/v1/attendance', component: redirectTo('/attendance?tab=team') },
  { path: '/v1/attendance-report', component: AttendanceReport },

  { path: '/v1/final-settlement/workspace/:resignationId', component: SettlementWorkspace },
  { path: '/v1/final-settlement', component: FinalSettlementEvaluations },
  { path: '/v1/resignations', component: ApprovedResignations },
  { path: '/v1/reimbursement-management', component: ReimbursementManagement },

  // Provident Fund
  { path: '/v1/provident-fund', component: ProvidentFundDashboard },
  { path: '/v1/provident-fund/employee/:id', component: EmployeePFView },

  // Loan Management
  { path: '/v1/accountant/loans', component: HrLoansPage },

  // Salary Revision (Accountant: read + arrears release)
  // NOTE: list before :id to preserve React Router ordering
  { path: '/v1/salary-revisions', component: SalaryRevisionList },
  { path: '/v1/salary-revisions/:id', component: SalaryRevisionDetail },

  // Approval Engine — was missing from accountantsConfig
  { path: '/v1/pending-approvals', component: PendingApprovals },

];

export default accountantRoutesConfig;